import React from 'react';
import ReactDOM from 'react-dom/client';
import {
	BrowserRouter,
	HashRouter,
	Route,
	Switch,
	Redirect,
} from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { isAuthenticated } from 'common';
import 'react-spring-bottom-sheet/dist/style.css';
// Library
import 'assets/css/slick.min.css'
import 'assets/css/slick-theme.min.css'
import 'assets/scss/argon-dashboard-react.scss';
import 'assets/css/font-awesome.min.css'

// Layout display
import AdminLayout from 'layouts/Admin';
import AuthLayout from 'layouts/Auth';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import store from 'store';
import { Provider } from 'react-redux';
import ToastContainer, { toastRef } from 'components/Toast';
import OnlineBooking from 'views/new-appointment/booking/OnlineBooking';
import StaffInformation from 'views/landing-page-setting/StaffInformation';
import NotificationList from 'views/notification/components/NotificationList';
import NotificationModal, { notificationRef } from 'components/Modal/NotificationModal';

// Native app loads from capacitor://localhost (no server) → HashRouter avoids
// real path resolution that breaks navigation. Web keeps clean URLs via BrowserRouter.
// Annotated as a generic component type: the ternary's two branches are different
// concrete router component types, which TSX can't call as JSX without a common signature.
const Router: React.ComponentType<any> = Capacitor.isNativePlatform() ? HashRouter : BrowserRouter;

function ErrorFallback({ error }: FallbackProps) {
	return (
		<div color="danger">
			<p>Something went wrong:</p>
			<pre>{error.message}</pre>
		</div>
	);
}

function App() {
	return (
		<Provider store={store}>
			<ErrorBoundary FallbackComponent={ErrorFallback}>
				<Router>
					<Switch>
						<Route
							path="/login"
							render={(props) => <AuthLayout {...props} />}
						/>
						<Route path='/:id/booking' render={() => <OnlineBooking />} />
						<Route path='/staff-information' render={() => <StaffInformation />} />
						<Route path='/notifications' render={() => <NotificationList />} />
						<Route
							path="/"
							render={(props) =>
								isAuthenticated() ? (
									<AdminLayout {...props} />
								) : (
									<Redirect
										to={{
											pathname: '/login',
											state: { from: props.location },
										}}
									/>
								)
							}
						/>
					</Switch>
				</Router>
				<ToastContainer ref={toastRef} />
				<NotificationModal ref={notificationRef} />
			</ErrorBoundary>
		</Provider>
	)
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
